<template>
    <section>
      <div v-if="full">
        <div class="col-md-12" v-if="loading" style="width: 80px">
          <LoadingSpinnerBar></LoadingSpinnerBar>
        </div>
        <div v-else class="row text-black border m-2">
          <small>Total apollo: {{targetresult.total_contacts}}</small>
          <div
          v-if="targetresult.total_contacts > 0"
          class="progress border bg-secondary"
          :style="'height: 21px;padding-right:10px; padding-left:5px'">
            <div
            class="progress-bar pt-2  bg-secondary"
            role="progressbar"
            :style="'width: 100%;margin-top: -7px;'">

              <div class="row  px-2">
                <ProgressBar  
                v-if="targetresult.used_target > 0"
                :title="'Used'" 
                :quantity="targetresult.used_target" 
                :total="parseInt(total)"></ProgressBar>
                <ProgressBar 
                v-else
                :title="'Used'" 
                :quantity="0" 
                :total="parseInt(total)"></ProgressBar>
              </div>
              <span v-if="loading"  class="loadingres mr-1 ml-1 spinner-border loading-spinner text-white"></span>
            </div>
          </div>
        </div>
      </div>
        <div v-if="!full && targetresult.total_contacts" class="contacts-situation-row">
            <button
              class="btn btn-sm btn-outline-primary contacts-situation-expand"
              v-if="isSmall"
              :disabled="loading"
              @click="isSmall = false"
            >
              <i class="icon-plus"></i>
            </button>
            <button
              class="btn btn-sm btn-primary float-right"
              v-if="!isSmall && targetresult.salesridge_data"
              :disabled="loading"
              @click="calculatedetails()"
            >
              <i class="icon-refresh"></i>
            </button>
            <span class="text-muted" v-if="!targetresult.salesridge_data && !isSmall">
              <span class="icon-circle"></span> SalesRidge stats not loaded
            </span>
            <div class="contacts-situation-bar">
              <PercentageBar
                :targetresult="targetresult"
                :target_id="target_id"
                :small="isSmall"
                :barOnly="isSmall"
                @getAvailableContacts="getAvailableContacts"
              />
            </div>
        </div>
        <div v-if="!full && !targetresult.total_contacts">
          - no info -
        </div>
        <LoadingSpinnerBar v-if="loading"></LoadingSpinnerBar>
    </section>
</template>

<script>
import { targetsService } from "@/_services";

import ProgressBar from "@/components/Common/ProgressBar.vue"; 
import LoadingSpinnerBar from "@/components/LoadingSpinnerBar.vue";
import PercentageBar from "@/components/Common/PercentageBar.vue";


export default {
  data() {
    return { 
      targetresult:[],
      loading:true,
      total: 0,
      isSmall: false,
    }
  },
  components:{
    ProgressBar,
    LoadingSpinnerBar,
    PercentageBar
  },
  props: {
    target_id:false,
    full:{
      type:Boolean,
      default:false
    },
    small:{
      type:Boolean,
      default:false
    },
  },

  created() {
    this.loading = true;
    this.loadApollo();
    this.isSmall = this.small;
  },

  methods: {  

    getAvailableContacts(data){      
      this.$emit('getAvailableContacts', data);
    },
    potentialTotal(){
      if(this.targetresult.total_contacts > this.targetresult.imported){
        return true
      }
      return false
    },  
    loadApollo(){
      targetsService.getTargetApolloDetails(this.target_id).then((result) => {
          if(result[0] != undefined){
            this.targetresult = result[0]
            if(!this.targetresult.avg_emails){
              this.targetresult.avg_emails = 0
            }
          }

          if(parseInt(this.targetresult.imported) >= parseInt(this.targetresult.total_contacts)) {
            this.total = this.targetresult.imported
          }else{
            this.total = this.targetresult.total_contacts
          }
          this.loading=false
      });
    },
    calculatedetails(){
      this.loading = true;
      targetsService.calculateDetails(this.target_id).then((result) => {
        this.loading = false;
        this.loadApollo();
      });
    },
    getPercentage(){
      if(this.total)
       return ((this.targetresult.used_target * 100) / this.total).toFixed(2);
    },
    getclass(){
      if(((this.targetresult.used_target * 100) / this.total).toFixed(2) > 90){
        return "badge-danger text-white";
      }
      if(((this.targetresult.used_target * 100) / this.total).toFixed(2) > 60){
        return "badge-warning text-white";
      }
      return "badge-success text-white";
    },
    getclassSent(){

      if(this.targetresult.avg_emails < 15){
        return "badge-danger text-white";
      }
      if(this.targetresult.avg_emails < 20){
        return "badge-warning text-white";
      }
      return "badge-success text-white";
    },
    finished(){
      if(this.getPercentage() > 90 && targetresult.avg_emails == 0){
        return true;
      }
      return false;
    },
    getclassUsed(){
      if(this.targetresult.success < 0.1){
        return "badge-danger text-white";
      }
      if(this.targetresult.success < 0.5){
        return "badge-warning text-white";
      }
      return "badge-success text-white";
    }
  }

}
</script>

<style scoped>
.contacts-situation-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 240px;
}

.contacts-situation-expand {
  flex-shrink: 0;
}

.contacts-situation-bar {
  flex: 1;
  min-width: 0;
}
</style>